// extracted by mini-css-extract-plugin
export default {"contentSection":"mobile-layout_contentSection__vDEy4","contentHasNotFooter":"mobile-layout_contentHasNotFooter__oc94e","noBottomMargin":"mobile-layout_noBottomMargin__QgYR6"};